'use client';

import type { CheckboxCheckedChangeDetails } from '@chakra-ui/react';
import { createContext, useContext } from 'react';

// ============================================================================
// Selection Context
// ============================================================================

export type SelectionCheckboxProps = {
	checked:         'indeterminate' | boolean
	onCheckedChange: (details: CheckboxCheckedChangeDetails) => void
};

export type SelectionContextValue = {
	headerSelection?: SelectionCheckboxProps
	selectable:       boolean
	rowSelection?:    (id: number | string) => SelectionCheckboxProps
};

export const SelectionContext = createContext<null | SelectionContextValue>(null);

export function useSelectionContext() {
	return useContext(SelectionContext);
}
